import {
    Component,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { FileType, ObjectTypes } from '@fi-shared/types';
import { FiBtnUploadFileComponent } from '@fi-shared/fi-insert-media/btn-upload-file/btn-upload-file.component';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { CheckpointModel } from '@fi-app/checklist/checkpoint.model';
import { getAcceptByFileType } from '@fi-shared/utils/get-accept-by-file-type';
import { FiExifHelperService } from '@fi-shared/fi-insert-media/fi-exif-helper.service';

@Component({
    selector: 'fi-checklist-checkpoint-add-media',
    template: `
        <button
          class="task-edit-open-insert-media"
          mat-button
          [disabled]="ngDisabled"
          (click)="openInsertMediaDialog()"
          >
          <span class="fa fa-lg fa-paperclip"></span>
          @if (ngModel.length === 0) {
            <span
              class="btn-text"
              [class.BrandedColor]="!ngDisabled && control && control.valid"
              [class.invalid]="control && !control.valid"
              >
              {{ attachFileText }} {{ control && !control.valid ? '*' : '' }}
            </span>
          }
        </button>
        `,
    styleUrls: ['./checkpoint-add-media.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChecklistCheckpointAddMediaComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChecklistCheckpointAddMediaComponent,
            multi: true,
        },
    ],
    host: { class: 'fi-checklist-checkpoint-add-media' },
    standalone: false,
})
export class FiChecklistCheckpointAddMediaComponent
    extends ControlValueAccessorValidatorBase<IMediaBankFileReference[]>
    implements OnChanges, OnInit
{
    @Input() checkpoint: CheckpointModel;
    @Input() ngRequired: boolean;
    @Input() ngDisabled: boolean;
    @Input() attachFileText: string;
    @Input() control: FormControl;

    @Output() onValidation = new EventEmitter();

    @ViewChild(FiBtnUploadFileComponent, { static: false }) btnFileUpload: FiBtnUploadFileComponent;

    constructor(
        private injector: Injector,
        private customerDataService: FiCustomerDataService,
        private insertMedia2Service: FiInsertMedia2Service,
        private fiExifHelperService: FiExifHelperService,
    ) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateValidation();
    }

    updateValidation() {
        if (this.control) {
            this.control.updateValueAndValidity();
        }
    }

    doValidate(): ValidationErrors {
        this.validationChange();
        return {
            required:
                this.ngRequired === true && this.ngDisabled !== true && (!this.ngModel || this.ngModel.length === 0),
        };
    }

    ngOnInit() {
        // this.updateValidation();
    }

    validationChange() {
        setTimeout(() => this.onValidation.emit(this.control.valid), 50);
    }

    private shouldCheckCreationDate() {
        return this.checkpoint.IsAttachmentMandatoryOk || this.checkpoint.IsAttachmentMandatoryNotOk;
    }

    openInsertMediaDialog() {
        this.insertMedia2Service
            .openInsertMediaDialogWithFileSizes(ObjectTypes.CheckPointAnswer, {
                accept: getAcceptByFileType(
                    [FileType.Image, FileType.Movie, FileType.Pdf, FileType.Excel],
                    ['.csv', 'application/vnd.oasis.opendocument.spreadsheet'],
                ),
                onFilesSelecting: (files) => {
                    if (!this.shouldCheckCreationDate()) {
                        return Promise.resolve(true);
                    }
                    return this.fiExifHelperService.checkFileImagesCreationDate(
                        files,
                        this.customerDataService.checklistAttachmentOldTimeIntervalMs,
                    );
                },
                onMediaBankFilesInserting: (attachments) => {
                    if (!this.shouldCheckCreationDate()) {
                        return Promise.resolve(true);
                    }
                    // check only existing files
                    const mediaBankFiles = attachments
                        .filter((attachment) => !attachment.file)
                        .map((attachment) => attachment.mediaBankFile);
                    return this.fiExifHelperService.checkMediaBankFilesCreationDate(
                        mediaBankFiles,
                        this.customerDataService.checklistAttachmentOldTimeIntervalMs,
                    );
                },
            })
            .onYesButtonClick((result) => {
                this.ngModel = this.ngModel.concat(result.mediaBankFileReferences);
                this.doPropagateChanges();
                this.validationChange();
            });
    }
}
